import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
const Rooms = () => {
  return (
    <div className="rooms">
      <div className="rooms-container">
        <div className="rooms">
          <div className="room-container-new">
            <img className="room1" src="/Assets/room1.webp" alt="room1"></img>
            <div className="rooms-content">
              <div className="rooms-logo-content">
                <img
                  className="rooms-logo"
                  src="/Assets/our-room-logo.webp"
                  alt="logo"
                ></img>
              </div>
              <div className="room-content-text">
                <p className="rooms-heading">DELUXE</p>
                <div className="room-heading-bottom-line"></div>
                <div className="room-image-container">
                  <div className="rooms-sm-logo-container1">
                    <img
                      className="rooms-sm-logo"
                      alt="items"
                      src="/Assets/swiper-our-rooms.webp"
                    ></img>
                  </div>
                  <div className="rooms-sm-logo-container2">
                    <img
                      className="rooms-sm-logo"
                      alt="items"
                      src="/Assets/fridge.png"
                    ></img>
                  </div>

                  <div className="rooms-sm-logo-container3">
                    <img
                      className="rooms-sm-logo"
                      alt="items"
                      src="/Assets/call-our-rooms.webp"
                    ></img>
                  </div>
                  <div className="rooms-sm-logo-container4">
                    <img
                      className="rooms-sm-logo"
                      alt="items"
                      src="/Assets/washing-machine-our-rooms.webp"
                    ></img>
                  </div>

                  <div className="rooms-sm-logo-container5">
                    <img
                      className="rooms-sm-logo"
                      alt="items"
                      src="/Assets/swimming-pool.png"
                    ></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rooms">
          <div className="room-container-new">
            <img className="room1" src="/Assets/room2.webp" alt="room1"></img>
            <div className="rooms-content">
              <div className="rooms-logo-content">
                <img
                  className="rooms-logo"
                  src="/Assets/our-room-logo.webp"
                  alt="logo"
                ></img>
              </div>
              <div className="room-content-text">
                <p className="rooms-heading">SUITE</p>
                <div className="room-heading-bottom-line"></div>
                <div className="room-image-container">
                  <div className="rooms-sm-logo-container1">
                    <img
                      className="rooms-sm-logo"
                      alt="items"
                      src="/Assets/swiper-our-rooms.webp"
                    ></img>
                  </div>
                  <div className="rooms-sm-logo-container2">
                    <img
                      className="rooms-sm-logo1"
                      alt="items"
                      src="/Assets/fridge-our-rooms.webp"
                    ></img>
                  </div>
                  <div className="rooms-sm-logo-container3">
                    <img
                      className="rooms-sm-logo"
                      alt="items"
                      src="/Assets/call-our-rooms.webp"
                    ></img>
                  </div>
                  <div className="rooms-sm-logo-container4">
                    <img
                      className="rooms-sm-logo"
                      alt="items"
                      src="/Assets/washing-machine-our-rooms.webp"
                    ></img>
                  </div>
                  <div className="rooms-sm-logo-container5">
                    <img
                      className="rooms-sm-logo"
                      alt="items"
                      src="/Assets/swimming-pool-our-rooms.webp"
                    ></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="swiper-rooms">
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 1000, disableOnInteraction: false }}
          loop
          slidesPerView={1}
        >
          <SwiperSlide>
            <div className="room-container-new">
              <img className="room1" src="/Assets/room1.webp" alt="room1"></img>
              <div className="rooms-content">
                <div className="rooms-logo-content">
                  <img
                    className="rooms-logo"
                    src="/Assets/our-room-logo.webp"
                    alt="logo"
                  ></img>
                </div>
                <div className="room-content-text">
                  <p className="rooms-heading">DELUXE</p>
                  <div className="room-heading-bottom-line"></div>
                  <div className="room-image-container">
                    <div className="rooms-sm-logo-container1">
                      <img
                        className="rooms-sm-logo"
                        alt="items"
                        src="/Assets/swiper-our-rooms.webp"
                      ></img>
                    </div>
                    <div className="rooms-sm-logo-container2">
                      <img
                        className="rooms-sm-logo"
                        alt="items"
                        src="/Assets/fridge.png"
                      ></img>
                    </div>

                    <div className="rooms-sm-logo-container3">
                      <img
                        className="rooms-sm-logo"
                        alt="items"
                        src="/Assets/call-our-rooms.webp"
                      ></img>
                    </div>
                    <div className="rooms-sm-logo-container4">
                      <img
                        className="rooms-sm-logo"
                        alt="items"
                        src="/Assets/washing-machine-our-rooms.webp"
                      ></img>
                    </div>

                    <div className="rooms-sm-logo-container5">
                      <img
                        className="rooms-sm-logo"
                        alt="items"
                        src="/Assets/swimming-pool.png"
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="room-container-new">
              <img className="room1" src="/Assets/room2.webp" alt="room1"></img>
              <div className="rooms-content">
                <div className="rooms-logo-content">
                  <img
                    className="rooms-logo"
                    src="/Assets/our-room-logo.webp"
                    alt="logo"
                  ></img>
                </div>
                <div className="room-content-text">
                  <p className="rooms-heading">SUITE</p>
                  <div className="room-heading-bottom-line"></div>
                  <div className="room-image-container">
                    <div className="rooms-sm-logo-container1">
                      <img
                        className="rooms-sm-logo"
                        alt="items"
                        src="/Assets/swiper-our-rooms.webp"
                      ></img>
                    </div>
                    <div className="rooms-sm-logo-container2">
                      <img
                        className="rooms-sm-logo1"
                        alt="items"
                        src="/Assets/fridge-our-rooms.webp"
                      ></img>
                    </div>
                    <div className="rooms-sm-logo-container3">
                      <img
                        className="rooms-sm-logo"
                        alt="items"
                        src="/Assets/call-our-rooms.webp"
                      ></img>
                    </div>
                    <div className="rooms-sm-logo-container4">
                      <img
                        className="rooms-sm-logo"
                        alt="items"
                        src="/Assets/washing-machine-our-rooms.webp"
                      ></img>
                    </div>
                    <div className="rooms-sm-logo-container5">
                      <img
                        className="rooms-sm-logo"
                        alt="items"
                        src="/Assets/swimming-pool-our-rooms.webp"
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default Rooms;
